import { render, staticRenderFns } from "./RegionCourt.vue?vue&type=template&id=51d29956"
import script from "./RegionCourt.vue?vue&type=script&lang=js"
export * from "./RegionCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports